// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1GeZR","label":"LabeledBox_label__gl8l2"};